// ProjectReportsPanel — reports by project
const projectReportsList = [
  { id: "prj-001", project: "CTA Urbano Campinas", type: "Relatório técnico do projeto", generatedAt: "2026-06-10", status: "Aprovado", responsible: "Eng. Flora Mendes" },
  { id: "prj-002", project: "CTA Urbano Campinas", type: "Relatório de progresso", generatedAt: "2026-06-18", status: "Gerado", responsible: "Coord. Márcio Silva" },
  { id: "prj-003", project: "CTA Urbano Campinas", type: "Relatório de campo", generatedAt: "2026-06-19", status: "Gerado", responsible: "Téc. Carlos Santos" },
  { id: "prj-004", project: "CTA Urbano Campinas", type: "Relatório de qualidade do cadastro", generatedAt: "2026-06-15", status: "Em revisão", responsible: "Aud. Fernando Lopes" },
  { id: "prj-005", project: "CTA Urbano Campinas", type: "Relatório de equipe", generatedAt: "2026-06-15", status: "Arquivado", responsible: "Coord. Márcio Silva" },
  { id: "prj-006", project: "Inventário Parque das Acácias", type: "Relatório técnico do projeto", generatedAt: "2026-05-28", status: "Aprovado", responsible: "Eng. Flora Mendes" },
  { id: "prj-007", project: "Inventário Parque das Acácias", type: "Relatório de pendências", generatedAt: "2026-06-02", status: "Gerado", responsible: "Eng. Flora Mendes" },
  { id: "prj-008", project: "Inventário Parque das Acácias", type: "Relatório final de implantação do CTA", generatedAt: "2026-06-05", status: "Aprovado", responsible: "Eng. Flora Mendes" },
  { id: "prj-009", project: "Loteamento Green Park", type: "Relatório técnico do projeto", generatedAt: "2026-04-18", status: "Em revisão", responsible: "Eng. Rafael Torres" },
  { id: "prj-010", project: "Loteamento Green Park", type: "Relatório de campo", generatedAt: "2026-05-12", status: "Gerado", responsible: "Téc. Carlos Santos" },
  { id: "prj-011", project: "CTA Vinhedo", type: "Relatório de progresso", generatedAt: "2026-06-19", status: "Gerado", responsible: "Coord. Márcio Silva" },
  { id: "prj-012", project: "CTA Vinhedo", type: "Relatório de pendências", generatedAt: "2026-06-19", status: "Gerado", responsible: "Coord. Márcio Silva" },
  { id: "prj-013", project: "CTA Zona Sul", type: "Relatório de campo", generatedAt: "2026-06-19", status: "Gerado", responsible: "Coord. Márcio Silva" },
  { id: "prj-014", project: "Inventário Guarulhos", type: "Relatório de qualidade do cadastro", generatedAt: "", status: "Rascunho", responsible: "Aud. Fernando Lopes" },
];

const statusBadge: Record<string, string> = {
  "Aprovado": "bg-primary-100 text-primary-700",
  "Gerado": "bg-primary-100 text-primary-700",
  "Em revisão": "bg-yellow-100 text-yellow-700",
  "Arquivado": "bg-background-200 text-foreground-500",
  "Rascunho": "bg-background-200 text-foreground-600",
};

export default function ProjectReportsPanel() {
  return (
    <div className="space-y-4">
      <h3 className="text-sm font-semibold text-foreground-900">Relatórios por Projeto</h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-background-200">
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Projeto</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Tipo de relatório</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Última geração</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Status</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Responsável</th>
              <th className="text-left py-2.5 px-3 text-xs font-semibold text-foreground-500 uppercase">Ações</th>
            </tr>
          </thead>
          <tbody>
            {projectReportsList.map((r) => (
              <tr key={r.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="py-2.5 px-3 text-foreground-900 font-medium">{r.project}</td>
                <td className="py-2.5 px-3 text-foreground-600 text-xs">{r.type}</td>
                <td className="py-2.5 px-3 text-foreground-500 text-xs">{r.generatedAt || "Pendente"}</td>
                <td className="py-2.5 px-3">
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium ${statusBadge[r.status] || "bg-background-100 text-foreground-500"}`}>
                    {r.status}
                  </span>
                </td>
                <td className="py-2.5 px-3 text-foreground-600 text-xs">{r.responsible}</td>
                <td className="py-2.5 px-3">
                  <div className="flex items-center gap-1">
                    <button title="Visualizar" className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-primary-600 hover:bg-primary-50 transition-colors">
                      <i className="ri-eye-line w-4 h-4 flex items-center justify-center text-sm" />
                    </button>
                    <button title="Baixar" className="w-7 h-7 rounded-md flex items-center justify-center text-foreground-400 hover:text-accent-600 hover:bg-accent-50 transition-colors">
                      <i className="ri-download-line w-4 h-4 flex items-center justify-center text-sm" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}